import { MasterDocument } from '@util/firestore/master';

interface YouTubeVideo {
  videoId: string;
  url: string;
  title: string;
  channel: string;
  date?: string;
  views?: number;
  duration?: number;
  featured?: boolean;
}

interface VideosSectionProps {
  master: MasterDocument;
}

/**
 * Returns the primary (featured/most-viewed) video and additional videos.
 */
export function getVideosSplit(master: MasterDocument): {
  primaryVideo: YouTubeVideo | null;
  additionalVideos: YouTubeVideo[];
} {
  const videos = master.youtube_videos as YouTubeVideo[] | undefined | null;
  if (!videos || videos.length === 0) {
    return { primaryVideo: null, additionalVideos: [] };
  }

  const featuredVideo = videos.find((v) => v.featured === true);
  const primaryVideo: YouTubeVideo = featuredVideo
    ? featuredVideo
    : [...videos].sort((a, b) => (b.views ?? 0) - (a.views ?? 0))[0];

  const additionalVideos = videos.filter((v) => v.videoId !== primaryVideo.videoId);

  return { primaryVideo, additionalVideos };
}

export default function VideosSection({ master }: VideosSectionProps) {
  const { primaryVideo } = getVideosSplit(master);

  if (!primaryVideo) {
    return null;
  }

  return (
    <div>
      <div className="aspect-video w-full">
        <iframe
          className="w-full h-full rounded-[0.8rem]"
          src={`https://www.youtube.com/embed/${primaryVideo.videoId}`}
          title={primaryVideo.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <p className="text-[1.4rem] text-gray-600 mt-[0.8rem]">
        {primaryVideo.title} — {primaryVideo.channel}
      </p>
    </div>
  );
}
